<script>
import Layout from '@layouts/guest.vue'
import { authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Page not found',
    meta: [{ name: 'description', content: 'Page not found' }],
  },
  components: { Layout },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <Layout>
    <div class="block text-black text-xl my-12">
      Page not found
    </div>
    <router-link
      v-if="loggedIn"
      class="primary-button inline-block"
      :to="{
        name: 'company',
        params: {
          companyId:
            currentUser.default_company_id &&
            currentUser.default_company_id !== 0
              ? currentUser.default_company_id
              : currentUser.companies[0].id,
        },
      }"
      >Go to home</router-link
    >
    <router-link
      v-if="!loggedIn"
      class="primary-button inline-block"
      :to="{
        name: 'login',
      }"
      >Login</router-link
    >
  </Layout>
</template>
